import { render, staticRenderFns } from "./SampleNotification.vue?vue&type=template&id=0c74f713&scoped=true"
import script from "./SampleNotification.vue?vue&type=script&lang=ts"
export * from "./SampleNotification.vue?vue&type=script&lang=ts"
import style0 from "./SampleNotification.vue?vue&type=style&index=0&id=0c74f713&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c74f713",
  null
  
)

export default component.exports